import React from 'react';
import Header from '../Components/Header';

const PrivacyPolicy = () => {
    return (
        // <div className="min-h-screen bg-custom-white text-custom-blue">
        <div className="w-full px-4 sm:px-6 lg:px-16 xl:px-20 py-8 max-w-7xl pt-2 mx-auto bg-custom-white text-custom-blue ">
            <Header />
            <header className="bg-custom-yellow py-6 mt-4">
                <div className="max-w-4xl mx-auto px-4">
                    <h1 className="text-3xl font-bold">Privacy Policy</h1>
                    <p className="mt-2 text-custom-blue">Prapancha Pravasa Tours Private Limited</p>
                    <p className="text-sm">Effective Date: 27/6/2025 | Last Updated: 27/6/2025</p>
                </div>
            </header>
            <main className="max-w-4xl mx-auto px-4 py-8">
                <p className="mb-4">At Prapancha Pravasa Tours Private Limited, your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you visit our website, book our tours, or use our services.</p>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">1. Information We Collect</h2>
                    <p>We may collect the following types of information:</p>
                    <ul className="list-disc pl-6">
                        <li><strong>Personal Information:</strong> Name, email address, phone number, passport details, and other identity documents for bookings.</li>
                        <li><strong>Payment Information:</strong> Credit/debit card or bank details for secure payments (processed through third-party gateways).</li>
                        <li><strong>Travel Preferences:</strong> Accommodation type, food habits, special requests, etc.</li>
                        <li><strong>Usage Data:</strong> IP address, browser type, pages visited, and cookies.</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">2. How We Use Your Information</h2>
                    <p>We use your information to:</p>
                    <ul className="list-disc pl-6">
                        <li>Process bookings and payments</li>
                        <li>Provide customer support and travel updates</li>
                        <li>Send promotional emails or newsletters (only if opted in)</li>
                        <li>Improve our website and user experience</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">3. Sharing of Information</h2>
                    <p>We do not sell or rent your personal information. We may share your data with:</p>
                    <ul className="list-disc pl-6">
                        <li>Hotel and transportation partners (only what is necessary)</li>
                        <li>Government or legal authorities (if required by law)</li>
                        <li>Third-party service providers for payment or CRM management</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">4. Data Security</h2>
                    <p>We implement appropriate security measures (SSL encryption, firewalls, etc.) to protect your data. However, no method of transmission over the internet is 100% secure.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">5. Your Rights</h2>
                    <p>You have the right to:</p>
                    <ul className="list-disc pl-6">
                        <li>Access or correct your data</li>
                        <li>Withdraw consent for marketing communications</li>
                        <li>Request deletion of your data (subject to legal obligations)</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">6. Cookies</h2>
                    <p>We use cookies to improve your experience on our website. You can manage or disable cookies in your browser settings.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">7. Children’s Privacy</h2>
                    <p>Our services are not intended for children under 18 without parental consent.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">8. Changes to This Policy</h2>
                    <p>We may update this Privacy Policy periodically. Changes will be posted on this page with the revised date.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2">9. Contact Us</h2>
                    <p>If you have questions about this policy, contact:</p>
                    <p>Prapancha Pravasa Tours Private Limited</p>
                    <p>Address: 1st Cross Rd, Kirloskar Layout, Siddeshwar Layout, Soundarya Layout, Bengaluru, Sidedahalli, Karnataka 560070</p>
                    <p>Email: <a href="mailto:book@prapanchapravasa.com" className="underline">book@prapanchapravasa.com</a></p>
                    <p>Phone: 63602 04100</p>
                </section>
            </main>
            <footer className="bg-custom-yellow py-4 text-center">
                <p>&copy; 2025 Prapancha Pravasa Tours Private Limited. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default PrivacyPolicy;